import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AuthForm from "./components/Auth/AuthForm";
import AdminPortal from "./components/Website/AdminPortal";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GlobalLoader from "./global/Loader";
import logo from "./assets/Praxiti-Logo.png";
import "./App.css";

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <GlobalLoader />;

  return isAuthenticated ? children : <Navigate to="/" />;
}

function AppContent() {
  return (
    <>
      <header className="app-header">
        <img
          src={logo}
          alt="Praxiti Logo"
          className="logo"
        />
      </header>

      <Routes>
        <Route path="/" element={<AuthForm />} />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminPortal />
            </PrivateRoute>
          }
        />
      </Routes>

      <ToastContainer
        position="bottom-right"
        autoClose={2300}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
      />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
